<div class="page-layout-container">
  <div class="title-group">
    <h1>Manage Employee Access</h1>
  </div>

  <div *ngIf="successFlag" class="alert alert-success">{{ message }}</div>

  <div class="content-grid">
    <aside class="search-panel">
      <div class="search-box">
        <h3>Search Employee</h3>
        <app-active-emp
          [filterEmpName]="filterEmpName"
          (empName)="empNameSelected($event)"
        ></app-active-emp>

        <button
          mat-flat-button
          color="primary"
          class="action-btn"
          type="button"
          (click)="grantMenuAccess()"
        >
          Manage Employee Access
        </button>
      </div>
    </aside>

    <section class="menu-panel">
      <div class="menu-list" *ngIf="menus.length">
        <h2>Menu access for: {{ empName }}</h2>

        <div class="menu-item" *ngFor="let menu of menus">
          <div
            class="parent-row"
            [class.has-children]="menu.children?.length"
            (click)="menu.children?.length ? toggleMenu(menu) : null"
          >
            <label class="menu-parent" (click)="$event.stopPropagation()">
              <input
                type="checkbox"
                [checked]="menu.checked"
                (change)="
                  onParentCheckboxChange(menu, $any($event.target).checked)
                "
              />
              <span class="order">{{ menu.menuOrder }}</span>
              <span class="label-text">{{ menu.displayName }}</span>
            </label>

            <span class="toggle-icon" *ngIf="menu.children?.length">
              {{ isExpanded(menu) ? "▼" : "▶" }}
            </span>
          </div>

          <div
            class="menu-children"
            *ngIf="menu.children?.length && isExpanded(menu)"
          >
            <div class="menu-child" *ngFor="let child of menu.children">
              <label>
                <input
                  type="checkbox"
                  [checked]="child.checked"
                  (change)="
                    onChildCheckboxChange(
                      menu,
                      child,
                      $any($event.target).checked
                    )
                  "
                />
                <span class="order">{{ child.menuOrder }}</span>
                <span class="label-text">{{ child.displayName }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="no-menu" *ngIf="empName && !menus.length">
        No menu data available for selected employee.
      </div>
    </section>
  </div>
</div>
